import React, { useState, useEffect } from 'react'
import { Loader2 } from 'lucide-react'
import Header from './components/Header'
import DataViewer from './components/DataViewer'
import { apiService } from './services/apiService'

function App() {
  const [apiHealth, setApiHealth] = useState(null)

  // Check API health on startup
  useEffect(() => {
    checkApiHealth()
  }, [])

  const checkApiHealth = async () => {
    try {
      const health = await apiService.getHealth()
      setApiHealth(health)
    } catch (error) {
      console.error('API connection error:', error)
      setApiHealth(null)
    }
  }

  // Show loading while checking API
  if (apiHealth === null) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="flex items-center gap-3">
          <Loader2 className="animate-spin" size={24} />
          <span className="ml-2">Connecting to API...</span>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header 
        apiHealth={apiHealth}
        onRefreshHealth={checkApiHealth}
      />
      
      <main className="container mx-auto px-4 py-6">
        <DataViewer />
      </main>
    </div>
  )
}

export default App 